import PaymentMethod from "../../payments/models/PaymentMethod";
import {CancellationPaymentTypes} from "./CancelDetails";

export const CancellationReasons = {
  CantAfford: 'cant_afford',
  AccessToFeature: 'access_to_feature',
  NotAchievingGoals: 'not_achieving_goals',
  NotUsing: 'not_using',
  Cleanliness: 'cleanliness',
  Staff: 'staff',
  DontEnjoy: 'dont_enjoy',
  Other: 'other'
}

class CancelForm {
  payment_method = new PaymentMethod();
  terms_accepted = false;

  constructor(props) {
    Object.assign(this, props);
    this.payment_method = new PaymentMethod(this.payment_method);
  }

  isPayNow() {
    return this.payment_type !== CancellationPaymentTypes.Regular;
  }
}

export default CancelForm;